<div class="home7-blog-section mb-5">
  <div class="container-one">
    <div
      class="row mb-60 wow animate fadeInDown"
      data-wow-delay="200ms"
      data-wow-duration="1500ms"
      >
      <div
        class="col-lg-12 d-flex align-items-center justify-content-between flex-wrap gap-3"
        >
        <div class="section-title2 two">
          <span data-translation-key="buyer_homepage_read_our">{{ 'buyer_homepage.read_our' | translate }}</span>
          <h2>
            <span data-translation-key="buyer_homepage_exclusive">{{ 'buyer_homepage.exclusive' | translate }}</span>
            <span>&nbsp;</span>
            <span data-translation-key="buyer_homepage_content">{{ 'buyer_homepage.content' | translate }}</span>
          </h2>
        </div>
        <div class="slider-btn-grp four">
          <a
            class="view-button2"
            routerLink="/blogs"
            data-translation-key="buyer_homepage_view_all_article"
            >
            {{ 'buyer_homepage.view_all_article' | translate }}
            <div class="arrow">
              <svg
                width="13"
                height="13"
                viewBox="0 0 13 13"
                xmlns="http://www.w3.org/2000/svg"
                >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M11.0261 10.3381L1.68853 1L0.999512 1.68902L10.3376 11.0266L3.88123 11.0266L3.88123 12.0005L12 12.0005L12 3.88172L11.0261 3.88172L11.0261 10.3381Z"
                ></path>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12.15 3.73194L12.15 12.1507L3.73126 12.1507L3.73126 10.8768L9.97546 10.8768L0.787402 1.68924L1.68856 0.788085L10.8761 9.97615L10.8761 3.73194L12.15 3.73194ZM11.85 4.03194L11.1761 4.03194L11.1761 10.7004L1.68856 1.21236L1.21167 1.68924L10.6998 11.1768L4.03125 11.1768L4.03125 11.8507L11.85 11.8507L11.85 4.03194Z"
                ></path>
              </svg>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div class="row">
      <div
        class="col-lg-12 wow animate fadeInUp"
        data-wow-delay="200ms"
        data-wow-duration="1500ms"
        [attr.direction]="dir"
        >
        <div class="swiper home7-blog-slider">
          <div class="swiper-wrapper">
            @if (!isLoading) {
              @for (blogItem of blogItems; track blogItem) {
                <div class="swiper-slide">
                  <div
                    class="blog-card five"
                    style="min-height: 523px !important"
                    [routerLink]="['/blog-details', blogItem?.slug]"
                    >
                    <div class="blog-card-img-wrap">
                      <a
                        [routerLink]="['/blog-details', blogItem?.slug]"
                        class="card-img"
                        >
                        <img
                          [src]="blogItem?.featured_media"
                          alt="{{ blogItem?.title }}"
                          />
                        </a>
                      </div>
                      <div class="card-content">
                        <h4>
                          <a [routerLink]="['/blog-details', blogItem?.slug]">{{
                            blogItem?.title
                          }}</a>
                        </h4>
                        <p [innerHTML]="blogItem?.excerpt" class="ellipsis"></p>
                        <a
                          class="view-button"
                          [routerLink]="['/blog-details', blogItem?.slug]"
                          data-translation-key="buyer_homepage_read_more"
                          >
                          {{ 'buyer_homepage.read_more' | translate }}
                          <svg viewBox="0 0 13 20">
                            <polyline
                              points="0.5 19.5 3 19.5 12.5 10 3 0.5"
                            ></polyline>
                          </svg>
                        </a>
                      </div>
                      <div class="batch">
                        <a [routerLink]="viewAllLink" class="date">
                          {{ blogItem?.date | localDateTime }}
                        </a>
                      </div>
                    </div>
                  </div>
                }
              }
              @if (isLoading) {
                @for (item of [1, 2, 3, 4, 5]; track item) {
                  <app-skeleton-loader
                    class="swiper-slide col-3 ms-3"
                    type="auction-card"
                  ></app-skeleton-loader>
                }
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
